import { ChatBlockedAlert } from 'components/accountHome/ChatBlockedAlert/ChatBlockedAlert'
import { Button } from 'components/Button/Button'
import { CmsOpenLiveChatEvent } from 'events/customEvents/cmsOpenLiveChat'
import { AccountHomeKeys } from 'events/lib/accountHome'
import { useEvent } from 'events/useEvent'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

type TalkToSomeoneLinkItem = {
  text: string
  url: string
  elementId: Extract<AccountHomeKeys, 'accounthome_contactmedicare_click'>
}

function useTalkToSomeoneLinks () {
  const { t, i18n } = useTranslation('accountHome', {
    keyPrefix: 'talkToSomeone.links'
  })

  return useMemo(() => {
    const links = [
      {
        text: t('contactMedicare'),
        urls: {
          en: 'https://www.medicare.gov/talk-to-someone',
          es: 'https://es.medicare.gov/talk-to-someone'
        },
        elementId:
          'accounthome_contactmedicare_click' as TalkToSomeoneLinkItem['elementId']
      }
    ]

    return links.map(({ text, urls, elementId }) => ({
      text,
      url: urls[i18n.language as 'en' | 'es'],
      elementId
    }))
  }, [i18n.language, t])
}

type TalkToSomeoneProps = {
  className?: string
}
export const TalkToSomeone = ({ className }: TalkToSomeoneProps) => {
  const { t } = useTranslation('accountHome', { keyPrefix: 'talkToSomeone' })
  const { fireEvent } = useEvent('accountHome')
  const [popupError, setPopupError] = useState(false)

  const links = useTalkToSomeoneLinks()

  const handleLiveChat = () => {
    const event = new CmsOpenLiveChatEvent(true, (error) => {
      if (error) {
        setPopupError(true)
      }
    })
    document.dispatchEvent(event)
    fireEvent('accounthome_livechat_click')
  }

  function eventHandler (item: TalkToSomeoneLinkItem) {
    fireEvent(item.elementId, {
      linkText: item.text,
      linkUrl: item.url
    })
  }

  return (
    <div className={`${className}`}>
      <h2
        className="ds-text-heading--xl ds-u-margin-bottom--2 ds-u-lg-margin-bottom--3"
        id="talk-to-someone-heading"
      >
        {t('heading')}
      </h2>
      <nav aria-labelledby="talk-to-someone-heading">
        <ul className="ds-c-list ds-c-list--bare">
          <li>
            <Button
              className="ds-c-button ds-c-button--ghost ds-u-padding--0"
              onClick={handleLiveChat}
            >
              {t('links.liveChat')}
            </Button>
          </li>
          {links.map((item, idx) => (
            <li key={idx}>
              <a href={item.url} onClick={() => eventHandler(item)}>
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <div className="ds-u-margin-top--1">
        <p>{t('phoneContact')}</p>
      </div>

      {popupError && <ChatBlockedAlert />}
    </div>
  )
}
